const doc = [({"zh_tw":({"adminConstantAdminUserStatus":({"disabled":"禁用", "enabled":"啟用", "invited":"邀請"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;